import { useEffect, useState } from 'react';

/** Narrower than this, tour cards are centered instead of anchored. */
export const MIN_WIDTH_TO_ANCHOR = 1300;

export function useIsNarrowScreen(): boolean {
  const query = `(max-width: ${MIN_WIDTH_TO_ANCHOR - 1}px)`;
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mq.addEventListener('change', onChange);
    setIsNarrow(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return isNarrow;
}
